var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"bg-box"}),_c('div',{staticClass:"nav-container"},[_c('nav-bar')],1),_c('div',{staticClass:"main-container"},[_c('app-bar')],1),_c('Bottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }